import { styled, Typography } from '@mui/material'

export const HomeWrapper = styled('div')`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  margin-bottom: 50px;
  margin-top: 15px;
`

export const HomeHeader = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-top: 32px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 16px;
  }
`


export const HomeDescription = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
  margin-top: 28px;
  margin-bottom: 4px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 12px;
  }
`
